import { useEffect, useRef, type ReactNode } from 'react';
import { useNav } from '../app/nav.tsx';
import { Icon } from './Icon.tsx';

// Painel que sobe de baixo, com a mesma marcação do protótipo (sheet, sheet-head, sheet-body, sheet-actions).
export function Sheet(props: {
  title: string;
  sub?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  onBack?: () => void;
  chip?: ReactNode;
  steps?: [number, number];
  wide?: boolean; // no computador, painel mais largo (cobrança)
}) {
  const nav = useNav();
  const ref = useRef<HTMLDivElement>(null);
  // arrastar para baixo fecha
  useEffect(() => {
    const sh = ref.current;
    if (!sh) return;
    let y0 = 0, dy = 0, on = false;
    const down = (e: PointerEvent) => {
      const t = e.target as HTMLElement;
      if (!t.closest('.sheet-grab, .sheet-head') || t.closest('button')) return;
      // no computador o painel abre à direita: arrastar para baixo não fecha (usa o X ou Esc)
      if (window.matchMedia?.('(min-width: 1024px)').matches) return;
      on = true; y0 = e.clientY; dy = 0; sh.style.transition = 'none';
    };
    const move = (e: PointerEvent) => { if (!on) return; dy = Math.max(0, e.clientY - y0); sh.style.transform = `translateY(${dy}px)`; };
    const up = () => {
      if (!on) return; on = false;
      sh.style.transition = 'transform .22s cubic-bezier(.32,.72,0,1)';
      if (dy > 90) { sh.style.transform = 'translateY(100%)'; window.setTimeout(nav.close, 200); } else sh.style.transform = '';
    };
    sh.addEventListener('pointerdown', down);
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    return () => { sh.removeEventListener('pointerdown', down); window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); };
  }, [nav.close]);

  return (
    <>
      <div className="scrim" onClick={nav.close} aria-hidden="true" />
      <div className={'sheet' + (props.wide ? ' wide' : '')} role="dialog" aria-modal="true" aria-label={props.title} ref={ref}>
        <div className="sheet-grab" aria-hidden="true" />
        <div className={'sheet-head' + (props.steps ? ' no-line' : '')}>
          <div className="left">
            {props.onBack && <button aria-label="Voltar" onClick={props.onBack}><Icon name="back" /></button>}
            <div className="sh-t"><h2>{props.title}</h2>{props.sub && <small>{props.sub}</small>}</div>
          </div>
          <div className="sh-r">{props.chip}<button aria-label="Fechar" onClick={nav.close}><Icon name="close" /></button></div>
        </div>
        {props.steps && (
          <div className="wz-steps" role="group" aria-label={`Passo ${props.steps[0]} de ${props.steps[1]}`}>
            {Array.from({ length: props.steps[1] }, (_, i) => <i key={i} className={i < props.steps![0] ? 'on' : ''} />)}
          </div>
        )}
        <div className="sheet-body"><div className="wz-body">{props.children}</div></div>
        {props.actions && <div className="sheet-actions">{props.actions}</div>}
      </div>
    </>
  );
}
